import { Button, Space, Tag } from "antd";

export const channelStatusData = [
  {
    label: "审核中",
    value: 0,
    color: "blue",
  },
  {
    label: "通过",
    value: 1,
    color: "green",
  },
  {
    label: "驳回",
    value: 2,
    color: "red",
  },
];

export const channelTypeData = [
  {
    label: "分红代理",
    value: 0,
  },
  {
    label: "不分红代理",
    value: 1,
  },
];

export const channelLevelData = [
  {
    label: "省级",
    value: 1,
  },
  {
    label: "市级",
    value: 2,
  },
  {
    label: "区级",
    value: 3,
  },
];

export const columns = ({
  setModalFormData,
  setOpen,
  fetchAreaData,
  setAddProxyOpen,
  loadByIds,
  handlePass
}: {
  setModalFormData: any;
  setOpen: any;
  fetchAreaData: any;
  setAddProxyOpen: any;
  loadByIds: any;
  handlePass: any
}) => [
  {
    title: "用户昵称",
    dataIndex: "channelAgentNickName",
    key: "channelAgentNickName",
  },
  {
    title: "用户账号",
    dataIndex: "channelAgentMobile",
    key: "channelAgentMobile",
  },
  {
    title: "渠道代理推荐人ID",
    dataIndex: "channelAgentRecommendBusinessId",
    key: "channelAgentRecommendBusinessId",
  },
  {
    title: "渠道代理推荐人",
    dataIndex: "channelAgentRecommendNickName",
    key: "channelAgentRecommendNickName",
  },
  {
    title: "申请等级",
    dataIndex: "channelLevel",
    key: "channelLevel",
    render: (val: number) => {
      const level = channelLevelData.find((item) => item.value === val);
      return level ? level.label : "";
    },
  },
  {
    title: "申请地区",
    dataIndex: "channelLevel",
    key: "channelLevel",
    render: (val: string, rows: any) => {
      return `${rows.channelProvinceName || ""} ${
        rows.channelCityName ? ` - ${rows.channelCityName}` : ""
      }${rows.channelDistrictName ? ` - ${rows.channelDistrictName}` : ""}`;
    },
  },
  {
    title: "联系电话",
    dataIndex: "contactMobile",
    key: "contactMobile",
  },
  {
    title: "系统审核",
    dataIndex: "systemAudit",
    key: "systemAudit",
    render: (val: number,rows:any) => {
      return <Tag color={rows.applyUserNewDeviceCount >= rows.channelApplyDeviceCount ? "green" : "red"}>{rows.applyUserNewDeviceCount >= rows.channelApplyDeviceCount ? "已达标" : "不达标"}</Tag>;
    },
  },
  {
    title: "购买数量",
    dataIndex: "applyUserNewDeviceCount",
    key: "applyUserNewDeviceCount",
  },
  {
    title: "申请时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "状态",
    dataIndex: "channelStatus",
    key: "channelStatus",
    render: (val: number | string) => {
      const status = channelStatusData.find((item) => item.value === Number(val));
      return status ? <Tag color={status.color}>{status.label}</Tag> : "-";
    },
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "驳回原因",
    dataIndex: "rejectReason",
    key: "rejectReason",
  },
  {
    title: "操作",
    dataIndex: "id",
    key: "id",
    fixed: "right",
    // width: "120px",
    render: (val: string, rows: any) => {
     return Number(rows.channelStatus) === 0 ? (
        <Space>
          <Button
            size="small"
            // icon={setIcons("EditOutlined")}
            type="primary"
            onClick={(e) => {
              handlePass(rows)
            }}
          >
            通过
          </Button>
          <Button
            size="small"
            // icon={setIcons("EditOutlined")}
            danger
            onClick={(e) => {
              setModalFormData(rows)
              setOpen(true)
            }}
          >
            驳回
          </Button>
        </Space>
      ) : (
        <></>
      );
    },
  },
];
